<se-fe-modal seFeDataSize="medium" [seFeDataActions]="actions" (seFeAfterClose)="onModalClosed()">
  <div seFeModalHeader class="registration-warning-modal__header">
    <h2 id="registration-warning-modal-title" class="se-fe-modal__title registration-warning-modal__title">
      {{ 'LIST_VIEW.REGISTRATION_WARNING_MODAL.title' | translate }}
    </h2>
  </div>

  <se-fe-modal-content class="registration-warning-modal__content">
    <p class="registration-warning-modal__description">
      {{ 'LIST_VIEW.REGISTRATION_WARNING_MODAL.description' | translate }}
    </p>

    @for (registration of registrations; track registration.id) {
      <div class="registration-warning-modal__registration">
        <span class="registration-warning-modal__name">{{ registration.name }}</span>
        <a
          class="registration-warning-modal__view"
          se-fe-button-low
          [href]="registration.survey_url"
          [attr.aria-label]="
            'LIST_VIEW.REGISTRATION_WARNING_MODAL.view_registration' | translate: { name: registration.name }
          "
          target="_blank"
          rel="noopener noreferrer">
          {{ 'LIST_VIEW.REGISTRATION_WARNING_MODAL.view' | translate }}
          <se-fe-icon seFeDataName="open_in_new" seFeDataSize="700" [seFeDataMargin]="false"></se-fe-icon>
        </a>
      </div>
    }
  </se-fe-modal-content>
</se-fe-modal>
